import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectReleases } from 'app/pages/Home/slice/selectors';
import { selectMonthsInRange } from '../store/selectors';
import { buildMonthlySearchIndex } from '../utils/buildMonthlySearchIndex';

/**
 * Pre-built search index for the monthly timeline view.
 * Used by SearchField when timelineViewMode is 'monthly'.
 */
export function useMonthlySearchIndex() {
  const releases = useSelector(selectReleases);
  const months = useSelector(selectMonthsInRange);

  return useMemo(
    () => buildMonthlySearchIndex(releases, months),
    [releases, months]
  );
}
